function NAConverter(string){
  if(!string || string === '' || string === 'default'){
    return 'N/A'
  }
  return string
}

function isNA(value){
  return value === 'N/A'
}

export { NAConverter, isNA }
